<template>
    <b-tabs v-model="activeTab">
        <b-tab-item label="Productos">
           <ProductTable 
           :product-list-endpoint="productListEndpoint" 
           :product-detail-endpoint="productDetailEndpoint" 
           :createProduct="createProduct"
           :productDelete="productDelete"
           :categories="categoryList"
           :subcategories="subcategoriesAll"
           :exportProducts="exportProducts"
           :importUrl="importUrl"
           :csrfToken="csrfToken"/>
        </b-tab-item>

        <b-tab-item label="Subcategorias">
            <CategoryTable 
            :subcategory-list-endpoint="subcategoryListEndpoint"
            :categoryListEndpoint="categoryListEndpoint"
            :categories="categoryList"
            :categoryLoading="categoryLoading"
            :count="count"
            :page="page"
            :subCategories="subcategoryList"
            :isLoading="subsLoading"
            :subcategoryDetail="subcategoryDetail"
            :subAesthetic="subAesthetic"
            @loadSubs="fetchSubCategories"
            @loadCategories="fetchCategories"
            @pageChange="onPageChange"/>
        </b-tab-item>

        <b-tab-item label="Categorias">
            <ParentList
            :categoryDetailUrl="categoryDetailUrl"
            :categories="categoryList"
            :loading="categoryLoading"
            @loadCategories="fetchCategories"
            @loadSubs="fetchSubCategories"
            />
        </b-tab-item>
        <b-tab-item label="Filtros">
            <Filters
            :filtersListCreate="filtersListCreate"
            :filtersDetail="filtersDetail"
            :filterOptionListCreate="filterOptionListCreate"
            :filterOptionDetail="filterOptionDetail"
            :categoryList="categoryList"
            :subcategoriesAll="subcategoriesAll"
            />
        </b-tab-item>

    </b-tabs>

</template>

<script>
import ProductTable from "./components/ProductTable.vue"
import CategoryTable from "./components/CategoryTable.vue"
import ParentList from "./components/ParentList.vue"
import Filters from "./components/Filters.vue"

import {getHandler, debounce} from "./../../../services/http"

export default {
    name:"Catalog",
    components:{
        ProductTable,
        CategoryTable,
        ParentList,
        Filters
    },
    props: {
        productListEndpoint: {
            type:String,
            default:""
        },
        categoryListEndpoint:{
            type:String,
            defult:""
        },
        subcategoryListEndpoint:{
            type:String,
            defult:""
        },
        subcategoryListAll:{
            type:String,
            defult:""
        },
        productDetailEndpoint:{
            type:String,
            defult:""
        },
        subcategoryDetail:{
            type:String,
            defult:""
        },
        createProduct:{
            type:String,
            default:''
        },
        productDelete:{
            type:String,
            default:''
        },
        categoryDetailUrl:{
            type:String,
            default:''
        },
        exportProducts:{
            type:String,
            default:''
        },
        filtersListCreate:{
            type:String,
            default:""
        },
        filtersDetail:{
            type:String,
            default:""
        },
        filterOptionDetail:{
            type:String,
            default:""
        },
        filterOptionListCreate:{
            type:String,
            default:""
        },
        csrfToken:{
            type:String,
            default:""
        },
        importUrl:{
            type:String,
            default:""
        }
    },
    data() {
        return {
            activeTab:0,
            categoryList:[],
            subcategoryList:[],
            subcategoriesAll:[],
            count:0,
            page:1,
            subsLoading:false,
            categoryLoading:false
        }
    },
    methods:{
        async fetchSubCategories(){
            let url = `${ this.subcategoryListEndpoint}?page=${this.page}`
            this.subsLoading = true
            let response = await getHandler(url, {success:false, error:false})
            this.count = response.count
            this.subcategoryList = response.results
            console.log("subcategories", this.subcategoryList)
            this.subsLoading = false
        },
        async fetchCategories(){
            this.categoryLoading = true
            let response = await getHandler(this.categoryListEndpoint, {success:false, error:false})
            this.categoryList = response
            this.categoryLoading = false
        },
        async fetchAllSubcategories(){
            this.subcategoriesAll = await getHandler(this.subcategoryListAll, {success:false, error:false})
        },
        onPageChange(page){
            this.page = page
            this.fetchSubCategories()
        }
    },
    created(){
        this.fetchSubCategories()
        this.fetchCategories()
        this.fetchAllSubcategories()
    }
}
</script>

<style lang="scss" scoped="true">
  @import "./../../../scss/main.scss";
</style>